module.exports = __webpack_public_path__ + "static/media/Madfit-15.d7a87b68.jpg";